import { Users, Activity, ShieldCheck } from "lucide-react";

/**
 * Item #18 — Name the three moats once, plainly. Mirrors the three
 * defensible advantages identified in the competitive landscape
 * report: workflow moat (coach-owned), data moat (Readiness),
 * regulatory moat (COPPA/FERPA-first).
 */
const MOATS = [
  {
    icon: Users,
    title: "Coach-Owned Workflow",
    body: "The coach is the acquisition node — every studio brings its actors, families, and tapes onto one stack.",
  },
  {
    icon: Activity,
    title: "Readiness Data",
    body: "Proprietary signal that compounds with every assignment, practice session, and reviewed tape.",
  },
  {
    icon: ShieldCheck,
    title: "Youth-Safe by Architecture",
    body: "COPPA/FERPA-first from day one — parent visibility and moderated youth spaces aren't bolted on.",
  },
] as const;

export default function MoatsStrip() {
  return (
    <div className="mt-10 mb-2">
      <p className="text-center text-[11px] font-semibold uppercase tracking-[0.16em] text-primary mb-3">
        Why CastReady
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {MOATS.map((m) => {
          const Icon = m.icon;
          return (
            <div key={m.title} className="rounded-xl border border-border bg-card/60 backdrop-blur p-4">
              <div className="flex items-center gap-2 mb-1.5">
                <span className="inline-flex h-7 w-7 items-center justify-center rounded-lg bg-primary/10 text-primary">
                  <Icon className="h-3.5 w-3.5" />
                </span>
                <p className="text-sm font-semibold">{m.title}</p>
              </div>
              <p className="text-xs text-muted-foreground leading-snug">{m.body}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}